//后面原则上，翻译部分能用首字母大写的就首字母大写，这样即使在程序中需要使用全小写也可以直接toLowerCase()，
// 如果全小写的情况下又需要首字母大写就不太好弄
// ，当然如果基本能够确定没有问题的就可以全小写
//为了方便纯翻译的部分就不再额外写一份英文了（直接用key），所以直接最后导出zh 和当前en的一个merge
import zh from "./zh_CN";
let keys = {};
for (let x in zh) {
  keys[x] = x;
}
const en = {
  demo: "this is a demo",
  // 'Success':'Success',
  'Expand':'Expand',
  'Fold':'Fold',
  "This is the end": "No more {words}",
  Confirm: "Confirm",
  Processing: "processing",
  ok: "Ok",
  all: "All",
  nCol: "{num, plural,  =1 {1 Column} other {# Columns}}",
  chronological: "chronological sort",
  hide: "Hide",
  show: "Show",
  cancel: "Cancel",
  // 'loading':'loading',
  // 'tip':'tip',
  "long-press-to-save": "Long press to save, and forward to Moments",
  "long-press-to-save-1": "Long press to save",
  time: "Time",
  place: "Place",
  "slide-up": "Slide Up",
  phone: "Phone",
  validate: "Captcha",
  FormError: "Error",
  "send-validate": "Send Captcha",
  "check-validate": "Enter",
  "require-phone": "Login",
  "input-pass": "Password",
  "wrong-pass": "Sorry, wrong password! Please check!",
  "speaker-guest": "Speakers/Guests",
  "live-photo": "LIVE PHOTO",
  "live-video": "VIDEO",
  "fast-editing": "FAST EDITING",
  details: "Details",
  agenda: "Agenda",
  organizer: "Organizer",
  Introduction: "Introduction",
  // 'Time':'Time',
  // 'Place':'Place',
  "Recently-visited": "Recently visited",
  // 'Go':'Go',
  // 'Album':'Album',
  // 'Like':'Like',
  "all-in-one-image": "'all-in-one' image",
  "Click to view": "Go", //直接用Go了
  "Confirm deletion": "Confirm deletion?",
  "Album-OK": "OK",
  "Album-Cancel": "Cancel",
  // 'Back':'Back',
  // 'Loaded':'Loaded',
  //预约部分
  "Phone-Is-required": "Phone is required",
  "Name-Is-required": "Name is required",
  "City-Is-required": "City is required",
  "Date-Is-required": "Date is required",
  "PreOrder-Name": "Name",
  "PreOrder-Phone": "Phone",
  "PreOrder-City": "City",
  "PreOrder-Start": "Start date",
  "PreOrder-End": "Last date",
  "PreOrder-Main": "Contact us",
  "PreOrder-Hotline": "Hotline",
  "PreOrder-Tip":
    "Please keep your phone open, we will contact you as soon as possible.",
  "Please select service type": "Please select service type",
  "Date not right": "Ending date should be later than starting date",
  "Order fails": "Order fails, please call custom service",
  //大图
  "Full image": "Full image ",
  "BigPic-Likes": "{num, plural, =0 {like} =1 {# like} other {# likes}}",
  //代码中的字符串
  "Not Started": "Not Started",
  Ascending: "Ascending",
  Descending: "Descending",
  "Order received": "Order received",
  MAX_JIGSAW_NUM:
    "{num, plural, =1 {# photo} other {# photos}} could be split jointed at most by now",
  MAX_DOWNLOAD_NUM:
    "{num, plural, =1 {# photo} other {# photos}} could be downloaded at most by now",
  MAX_SHARE_NUM: "{num, plural, =1 {# photo} other {# photos}} could be share at most by now",
  "min-jigsaw":
    "{num, plural, =1 {# photo} other {# photos}} at least for collage",
  "min-download": "1 photo at least for download",
  "min-share": "1 photo at least for share",
  Collaging: "Collaging...",
  "Long-press to save": "Long-press to save",
  "photo update": "{num, plural,  =1 {1 photo} other {# photos}} updated",
  "share-default": "Jimage live photo, makes each shared moment wonderful!",
  //我的影集相关
  "my-album": "My album",
  "in-album": "Go",
  // 'Modify':'Modify',
  // 'Delete':'Delete',
  photo: "{num, plural, =0 {Photo} =1 {Photo} other {Photos}}",
  photos: "{num, plural, =0 {photo} =1 {photo} other {photos}}",
  photos2: "{num, plural, =0 {photo} =1 {photo} other {photos}}",
  album: "{num, plural, =0 {Album} =1 {Album} other {Albums}}",
  "current album": "Current Album",
  "My friends": "My friends",
  "Add friends": "Add friends",
  "album-tip": "TIPS",
  "album-tip-content":
    "For better facial recognition, please upload the unobscured, unbeautified, clear frontal portrait",
  "album-tip-content2": "", //空，原因见中文部分
  "Delete friend": "Delete friend?",
  "Max friend number":
    "The number of your friends has reached to 6, please delete someone if you want to add a new one.",
  "Max friend number2": "",
  "Name placeholder": "Please input name",
  "Name is required": "Name is required",
  "+friends": "+friends",
  "Know him/her": "Know him/her?",
  "No photos": "No photos",
  "No friends": "No data",
  HideAvatar: "Hide",
  ShowAvatar: "Show",
  "Wrong recognition": "Wrong recognition",
  "Please upload single frontal photo":
    "Please upload your photo, and make sure the frame is full filled with your front face",
  "after upload":
    "Please upload your photo, and make sure the frame is full filled with your front face, changing is not available after upload",
  "Changing frontal photo is not available now":
    "Changing frontal photo is not available now",
  "Upload and agree": "Upload and agree",
  "Jfoto service agreement": "service agreement",
  "for better service": "for better service",
  "Please read and agree to the agreement firstly":
    "Please read and agree to the agreement",
  "no sb": "Is there no {name} in this photo?",
  "Deleting is beyond retrieve": "Deleting is beyond retrieve",
  "photo of x": "{name}'s album",
  "detail avatar tip":
    "Click the portrait to review all photos of him/her in current album",
  Guide: "Guideline",
  "click the wrong recognition button":
    'Click the pictures below, and then click the "wrong recognition" button to delete the wrong recognized image.',

  // 下载挂件
  "Download-Pendent": "Save", // 字数考虑
  "Download-Pendent-Bottom": "Download",
  "ChooseShare": "Pick",
  "DownloadSuccess": "Download Success",

  //评论相关

  "Back Gallery": "Back",

  //弹幕
  DanmakuOn: "On",
  DanmakuOff: "Off",
  Border: "Border",
  Make: "Make",
  "Scan to visit": "Scan to visit",
  "Add border": "Add border",
  "Poster Building": "Poster Building",
  "Post Comment Error": "Post Error",
  Person: "Person",
  Hot: "Hot",
  "One Column": "One",
  "Two Column": "Two",
  "Four Column": "Four",
  Timeline: "Time",
  ASC: "Sequence",
  DESC: "Reverse",
  LiveGallery: "Live",
  Home: "Home",
  Followee: "Followee",
  Preorder: "Order",
  My: "My",
  MyPhoto: "My Photo",
  Photo: "photos",
  View: "views",
  "Unit Piece": " Photos",
  Waiting: "Waiting",
  Poster: "Poster",
  BigPicPoster:"Poster",
  PrintCurrentImage: "Print",
  Download: "Download",
  Downloading: "Downloading",
  "Switch Gallery": "Back Home",

  // 引导页
  "People see": "{num, plural, =1 {view} other {views}}",

  VideoPlaybackGenerating: "Replay is building",
  VideoPause: "Coming soom",
  VideoDirectEnd: "End of the Channel",
  VideoDirectEndStatus: "END",

  // 直播状态
  GalleryStatusComplete: "Wait Replay",
  GalleryStatusRollback: "Replay",
  GalleryStatusWait: "Coming Soon",
  GalleryStatusStart: "Live",
  GalleryStatusEnd: "Review",
  GalleryStatusAmazing: "HighLights",

  QrcodeNotice: "remind",
  QrcodeNoticeTitle: "Enable Notice",
  QrcodeNoticeFollow: "Follow us",
  QrcodeNoticeTips: "send a message before live",
  QrcodeNoticeCancel: "Cancel Success",
  QrcodeNoticeOrdered: "Ordered",

  "The live video is not started": "The Video is not start",
  "The live video is waiting replay": "The Video is end, wait for replay",

  "Redpack Opening": "Getting",

  // 关注列表
  "Fold friends":
    "Fold all {num, plural, =1 {# following} other {# followings}}",
  "Unfold friends":
    "Unfold all {num, plural, =1 {# following} other {# followings}}",

  // 红包
  "Limited Red Packet1": "Limited Red Packet",
  "Nth send time":
    "{num,plural, =1 {} =2 {#nd} =3 {#rd} other {#th}} red packet start time",
  "Opened and total": "Opened {n1}/{n2}, total {n3}/{n4} CNY",
  "Red Packet total num and money":
    "{n,plural, =1 {# red packet} other {# red packets}}, total {money} CNY",
  // 因为太长了显示不下，至少这样
  "Active face recognition": "Face recognition",
  // 同上
  "You and your followings are automatically recognized":
    "Automatically recognized",

  "##COMPANY": "Company",
  "##JOB": "Job",
  "##NAME": "Name",
  "##PHONE": "Phone",
  "##CITY": "City",
  "##EMAIL": "Email",
  "Signup to view": "Sign up",
  "Please input the": "Please input the ",
  "Please input the right": "Please input correct ",
  "Please choose": "select",
  CountryCode: "Area",
  MessageSendSuccess: "Message success",
  MessageSendError: "Message send error",
  PhoneCodeSuccess: "",
  PhoneCodeError: "Captcha error",
  PhoneCodeErrorWhite: "Captcha error or forbiden",
  "Red Packet transferred to Wallet":
    "Wait 1 to 5 minute, the Present would transfer to Wallet",

  More: "More",
  PeopleView: "users",
  PeopleCount: "Users",

  Comment: "Comment",
  Question: "qu.",
  Earliest: "Early",
  Lastest: "Last",
  Recomment: "Recomment",
  "Send Forbid": "Forbidden",
  MoreRecomment: "Show more {total} comments",
  Countdown: "Count",
  Day: "D",
  Hour: "H",
  Minute: "M.",
  Second: "S",
  Intro: "Introduction",
  Give: "Present",
  Given: "given",
  Unit: "Count",
  "Send Gift": "Gift",
  VIDEO_LIVE: "LIVE",
  CommentRepeat: "Error: Same with last commment",
  Share: "Share",
  Copyed: "Copyed",
  SaySomething: "Say something...",
  ClickAndLogin: "Please click to join",
  SelfCommentForbid: "You are being silenced",
  AllCommentForbid: "All Silenced",
  OnlyComment: "Comment",
  Send: "Send",
  Sending: "Sending",
  PostPaperSuccess: "Post Success",
  PostPaperError: "Post Error",
  PostPaperError200001: "Parent is not found",
  PostPaperError200202: "Permission Error",
  PostPaperError200208: "Code Error",
  PostPaperError200209: "Password Error",
  NoMorePhoto: "no more",
  MorePhoto: "New {num} Photos",
  ClickRefresh: "click to refresh",
  FaceRecognitionDesc:
    "Please upload a clear picture on the front and try to fill the frame with your face",
  Find: "Find",
  ZoomIn: "Zoom In",
  ZoomOut: "Zoom Out",
  FaceLoading: "recognizing",
  FindPeopleNoResult: "No photo with the face",
  FINDPEOPLE_ERROR_422: "No photo with the face",
  FINDPEOPLE_ERROR_222202: "No face in the photo",
  FINDPEOPLE_ERROR_222207: "No photo with the face",
  FINDPEOPLE_ERROR_222304: "Photo is too large then 2M bytes",
  DocumentEmpty: "No File",
  DocumentPlayAuto: "Auto",
  DocumentPlayCustom: "Manual",
  DocumentDoPager: "Flip ",
  On: "on",
  Off: "off",
  VoteJoin: " joined",
  VoteEnd: "Time Remaining",
  InputTheKeyword: "Please input keyword",
  Vote: "vote",
  Voted: "voted",
  VoteWait: "begin at ",
  VoteHadEnd: "This vote is end",
  VoteEmpty: "No option",
  ChatRoomJoin: "joined",
  ContactNow: "Contact us",
  Wechat: "chat",
  Phone: "call",
  WechatTips: "Long press to add wechat friend",
  SeeMore: "More",
  PleaseShare: "Please choose your share",
  ShareLink: "copy",
  ShareQrcode: "qrcode",
  LuckySubmit: "Submit",

  "Invited": "invited {n1}",
  "ToInvite": "share",
  "ShowMore": "More",
  "Me": "i",

  // 新的个人中心
  "SettingLang":"Language",
  "SettingPhotoSort":"Order Photo by",
  "SettingPhotoLayout":"Photo Layout",
  "SystemDefault":"Default",
  // 底部导航
  "FindPhoto":"Find",
  // 找照片中心
  "GalleryHistory":"History",
  "SplicePoster":"Poster",
  "FavPhoto":"Favorite",
  "PayedPhoto":"Bought",
  "VisitedPerson":"Person visited",
  "UploadPhotoFind": "Upload and search",
  "Cancel": "Cancel",
  "DeleteSuccess": "Success",
  "SetTop": "Sticky person",
  "CancelTop": "Cancel sticky",

  // 人物详情
  "CurrentGalleryPhoto": "Photo in the gallery",
  "HistoryGalleryPhoto": "More photo from your visited gallery",
  "ClickShare": "Share",
  "NoMatchPhoto": "No matching photo been found",

  // 付费
  "GalleryNeedPay": "Pay per view",
  "GalleryPayed": "Payed",
  "PayToRemove": "Pay per view",
  "GalleryPayTitle":"Paid album",
  "PayRule1":"1. After successful purchase, you can remove the watermark or download the photo",
  "PayRule2":"2. In the bottom navigation, \"Find Photos\" - \"Payed Photos\" can view all payed photos",
  "PayRule3":"3. No refunds are available after payment",
  "ReadyToPay":"Loading",

  "Please input gallery name": "Please input gallery name",
  "LoadError": "Load Error",
  "PersonShareTip": "After sharing, the face recognition results that your friends see may not be completely consistent with you, which is due to the different albums that you and your friends have visited, and the different AI recognition ranges. The other party sees the album photos that you are currently sharing and the album photos that they have visited in history",
  "PersonCustomShare": "Share Forward",
  "PersonCustomShareTitle": "Please change the title and description",
  "PersonCustomShareTitlePlaceholder": "the default title will be used if anything modified.",
  "SettingShare":"Edit Share Info",
  "PleaseSettingShare":"Please modify the share title and description",
  "IfNotEditUseDefaultShare":"Use default if nothing modified",
  "ConfirmSettingAndShare":"Confirm to share",

  "Submit": "Submit",
  "uploadTooltip": "Please input {title} to upload",
  "NoResult": "No result yet",
  "Failed": " Failed",
  "MaxFolloweeNum":
    "The number of people you followed has reached the upper limit, you can unfollow one person and then try to follow a new person.",
};

export default {
  ...keys,
  ...en,
};
